import { ApplicationConfig, provideBrowserGlobalErrorListeners, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
// import { authInterceptor } from './core/interceptors/auth.interceptor';
// import { crashInterceptor } from './core/interceptors/crash.interceptor';
import { provideNgxMask } from 'ngx-mask';

import { routes } from './app.routes';

//import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { HttpClient } from '@angular/common/http';
// import { CustomTranslateLoader } from './core/utils/translate.util';

// export function loaderFactory(http: HttpClient) {
//   return new CustomTranslateLoader(http);
// }

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes), 
    provideHttpClient(),
    //provideHttpClient(withInterceptors([authInterceptor, crashInterceptor])),
    provideNgxMask(),
    // importProvidersFrom(
    //   TranslateModule.forRoot({
    //     loader: {
    //       provide: TranslateLoader,
    //       useFactory: loaderFactory,
    //       deps: [HttpClient],
    //     },
    //   })
    // ),
  ]
};
